function icon_inspect() {

    return (
        <svg className="icon icon__inspect" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            width="26.787px" height="24.121px" viewBox="0 0 26.787 24.121" >
            <g>
                <path fill="#26245C" d="M18.424,12.515l-4.271,4.303c-0.201,0.268-0.146,0.646,0.121,0.848c0.215,0.162,0.512,0.162,0.728,0
                    l5.304-5.333c0.23-0.234,0.23-0.613,0-0.848l-5.304-5.334C14.8,5.884,14.42,5.83,14.152,6.03c-0.269,0.201-0.322,0.581-0.121,0.849
                    C14.064,6.925,14.105,6.966,14.152,7l4.271,4.304H0.605C0.271,11.304,0,11.574,0,11.909c0,0.334,0.271,0.605,0.605,0.605H18.424
                    L18.424,12.515z"/>
                <path fill="#26245C" d="M23.15,0H11.212C9.204,0,7.576,1.628,7.576,3.636l0,0V7.06c0,0.334,0.271,0.605,0.605,0.605
                    S8.788,7.394,8.788,7.06V3.636c0-1.339,1.085-2.424,2.424-2.424H23.15c1.34,0,2.425,1.085,2.425,2.424v16.848
                    c0,1.34-1.085,2.424-2.425,2.424H11.212c-1.339,0-2.424-1.084-2.424-2.424v-3.727c0-0.336-0.271-0.605-0.606-0.605
                    c-0.334,0-0.605,0.27-0.605,0.605v3.727c0,2.008,1.628,3.637,3.636,3.637H23.15c2.009,0,3.637-1.629,3.637-3.637V3.636
                    C26.787,1.628,25.159,0,23.15,0L23.15,0z"/>
            </g>
        </svg>
    )
}

export default icon_inspect